export const buildMaterialForm = (materials, fallbackTitle = "") => {
  const rows = Array.isArray(materials) ? materials.filter(Boolean) : [];
  const current = [...rows].sort((a, b) =>
    Number(b.is_primary || 0) - Number(a.is_primary || 0) || Number(b.material_id) - Number(a.material_id)
  )[0];
  return {
    enabled: Boolean(current),
    material_id: current?.material_id || null,
    pdf_url: current?.pdf_url || "",
    title: current?.title || fallbackTitle,
    revision: current?.revision || 1,
    is_primary: current ? Number(current.is_primary) : 1,
  };
};

export const saveEducationMaterial = async (api, scheduleId, form, file, fallbackTitle) => {
  if (!form.enabled) return;
  const payload = new FormData();
  payload.append("schedule_id", scheduleId);
  payload.append("title", String(form.title || fallbackTitle || "교육자료").trim());
  payload.append("revision", form.revision || 1);
  payload.append("is_primary", form.is_primary ? 1 : 0);
  if (file) payload.append("pdf", file);
  return form.material_id
    ? api.put(`/compliance/edu-materials/${form.material_id}`, payload)
    : api.post("/compliance/edu-materials", payload);
};
